var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHospitalinfoEmergency = function SvgHospitalinfoEmergency(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M25.96 10h-20v15h20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E2E2",
    d: "M24.96 11h-18v13h18z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    d: "M20.83 10h-.75c0-1.45-1.18-2.63-2.62-2.63h-3c-1.45 0-2.62 1.18-2.62 2.63h-.75c0-1.86 1.51-3.38 3.38-3.38h3c1.85 0 3.36 1.51 3.36 3.38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6726",
    d: "M17.46 16v-2h-3v2h-2v3h2v2h3v-2h2v-3z"
  })));
};
export default SvgHospitalinfoEmergency;